export default __webpack_public_path__ + "static/media/10-gm-unachieved.7a59d4fb.png";